/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable import/extensions, import/no-unresolved */

import Qs from 'qs'
import { HttpStatusCode } from '../../protocols/http/http-client'
import { UnauthorizedError } from '../../../domain/errors/unauthorized-error'
import { AccessDeniedError } from '../../../domain/errors/access-denied-error'
import { UnexpectedError } from '../../../domain/errors/unexpected-error'

export class RemoteGoalCalculations {
  url: string

  httpClient: any

  constructor(url: string, httpClient: any) {
    this.url = url
    this.httpClient = httpClient
  }

  async index(params?: any) {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'get',
      paramsSerializer(paramsAux: any) {
        return Qs.stringify(paramsAux, { arrayFormat: 'repeat' })
      },
      params,
    })

    switch (httpResponse.statusCode) {
      case HttpStatusCode.unauthorized: throw new UnauthorizedError()
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      case HttpStatusCode.ok: return httpResponse.body
      default: throw new UnexpectedError()
    }
  }

  async load(params?: any) {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'get',
      paramsSerializer(paramsAux: any) {
        return Qs.stringify(paramsAux, { arrayFormat: 'repeat' })
      },
      params,
    })

    switch (httpResponse.statusCode) {
      case HttpStatusCode.unauthorized: throw new UnauthorizedError()
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      case HttpStatusCode.ok: return httpResponse.body
      default: throw new UnexpectedError()
    }
  }

  async create(body: any) {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'post',
      data: body,
    })

    switch (httpResponse.statusCode) {
      case HttpStatusCode.unauthorized: throw new Error('Login e/ou senha incorretos.')
      case HttpStatusCode.notFound: throw new Error('Login e/ou senha incorretos.')
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      case HttpStatusCode.created: return httpResponse.body
      case HttpStatusCode.ok: return httpResponse.body
      default: throw new UnexpectedError()
    }
  }

  async post(data: any, params?: any) {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'post',
      data,
      params,
    })

    const backendMessage = Array.isArray(httpResponse.body) && httpResponse.body.length > 0
      ? httpResponse.body[0]?.msgUsuario
      : httpResponse.body?.msgUsuario || httpResponse.body?.message

    switch (httpResponse.statusCode) {
      case HttpStatusCode.unauthorized: throw new UnauthorizedError()
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      case HttpStatusCode.badRequest: throw new Error(backendMessage || 'Erro na requisição')
      case HttpStatusCode.created: return httpResponse.body
      case HttpStatusCode.ok: return httpResponse.body
      default: throw new UnexpectedError()
    }
  }

  async update(body: any) {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'put',
      data: body,
    })

    switch (httpResponse.statusCode) {
      case HttpStatusCode.unauthorized: throw new Error('Não autorizado.')
      case HttpStatusCode.notFound: throw new Error('Não encontrado.')
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      case HttpStatusCode.ok: return httpResponse.body
      default: throw new UnexpectedError()
    }
  }

  async delete() {
    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'delete',
    })

    switch (httpResponse.statusCode) {
      case HttpStatusCode.unauthorized: throw new UnauthorizedError()
      case HttpStatusCode.ok: return httpResponse.body
      case HttpStatusCode.noContent: return true
      case HttpStatusCode.forbidden: throw new AccessDeniedError()
      default: throw new UnexpectedError()
    }
  }
}
